export default __webpack_public_path__ + "static/media/UST_Rose.93c1b1cc.png";